import React, { useMemo, useRef, useState } from "react";

const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

export default function DentalAtt() {
  const localUser = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); } catch { return null; }
  }, []);
  const moduleId = parseInt(localUser?.moduleId, 10);

  const fileRef               = useRef(null);
  const [submitting, setSubmitting] = useState(false);
  const [error,   setError]   = useState("");
  const [success, setSuccess] = useState("");

  if (moduleId !== 4) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">Unauthorized access Or Session Timed out.</div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const file = fileRef.current?.files?.[0];
    if (!file) {
      setError("Please select a .txt file.");
      return;
    }

    const formData = new FormData();
    formData.append("FileName", file);

    try {
      setSubmitting(true);
      const res  = await fetch(`${API_ROOT}/api/attendance/upload-dental`, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Upload failed.");
      setSuccess(data.message);
      if (fileRef.current) fileRef.current.value = "";
    } catch (err) {
      setError(err.message || "Upload failed.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container-fluid mt-3">
      <h3 className="ctitle">Upload Attendance (Dental)</h3>

      {error   && <div className="alert alert-danger mt-2">{error}</div>}
      {success && <div className="alert alert-success mt-2">{success}</div>}

      <form onSubmit={handleSubmit} className="row g-2 align-items-end mt-2">
        <div className="col-sm-6">
          <label className="form-label">File Name</label>
          <input
            ref={fileRef}
            type="file"
            className="form-control"
            accept=".txt"
            required
          />
          <small className="text-muted">
            Accepted: <code>Teaching######.txt</code> or <code>NonTeaching######.txt</code>&nbsp;
            (date digits as DDMMYY)
          </small>
        </div>
        <div className="col-sm-3">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={submitting}
          >
            {submitting ? "Uploading..." : "Add Attendance"}
          </button>
        </div>
      </form>
    </div>
  );
}
